module.exports = __webpack_public_path__ + "img/de-palmas.0d27f300.jpg";